export default {"src":"/_next/static/media/pea.aeea896a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};